import {DateRangePicker} from "react-date-range";
import {useEffect, useState} from "react";
import "react-date-range/dist/styles.css"; // main style file
import "react-date-range/dist/theme/default.css"; // theme css file
import {vi} from 'date-fns/locale'
import moment from "moment";
import {Button, Col, Row, Switch} from "antd";
import {KeyConstant} from "../constant/keyConstant";
import {staticRanges} from "../common/staticRanges";
import {mapNameLastMonth} from "../common/mapNameLastMonth";
import {mapPeriod} from "../common/mapPeriod";
import {mapStartDatePeriod} from "../common/mapStartDatePeriod";
import {mapEndDatePeriod} from "../common/mapEndDatePeriod";
import {mapStartDatePeriodLast} from "../common/mapStartDatePeriodLast";
import {mapEndDatePeriodLast} from "../common/mapEndDatePeriodLast";
import {useDispatch, useSelector} from "react-redux";
import {useNavigate, useSearchParams} from "react-router-dom";
import {onReloadData} from "../../../../redux/actions/layout/interaction/action";

const styleRow = {
    borderTop: "1px solid #EAECF0"
}

const styleCol = {
    paddingTop: 14,
    width: 226,
    borderRight: "1px solid #eff2f7 "
}
const styleDiv = {
    color: "rgb(61, 145, 255)"
}

const styleColor = {
    color: "#667085"
}

const format = "YYYYMMDD"
const CalendarModal = ({onCancel, destroy, onDestroy}) => {

    const dispatch = useDispatch()
    const {reloadData} = useSelector(state => state.layoutInteractionReducer)
    const [searchParams] = useSearchParams()
    const navigate = useNavigate();
    const [selectedDateRange, setSelectedDateRange] = useState({
        startDate: moment().subtract(28, "days").toDate(),
        endDate: moment().subtract(1, "days").toDate(),
        key: "selection"
    });
    const [compare, setCompare] = useState(false)
    const [compareType, setCompareType] = useState("previousPeriod")
    const [type, setType] = useState(KeyConstant.THIRTY_DAYS_AGO)
    const [checkCustom, setCheckCustom] = useState(false)

    const [selectedDateRangeTemp, setSelectedDateRangeTemp] = useState({
        startDate: moment().subtract(28, "days").toDate(),
        endDate: moment().subtract(1, "days").toDate(),
        key: "selection"
    });
    const [compareTemp, setCompareTemp] = useState(false)
    const [compareTypeTemp, setCompareTypeTemp] = useState("previousPeriod")
    const [typeTemp, setTypeTemp] = useState(KeyConstant.THIRTY_DAYS_AGO)
    const [checkCustomTemp, setCheckCustomTemp] = useState(false)

    useEffect(()=>{

        let range = {
            startDate: searchParams.get("startDate") ? moment(searchParams.get("startDate")).toDate() :
                moment().subtract(28, "days").toDate(),
            endDate: searchParams.get("endDate") ? moment(searchParams.get("endDate")).toDate() :
                moment().subtract(1, "days").toDate(),
            key: "selection"
        }
        setSelectedDateRange(range)
        setCompare(searchParams.get("compare") ? searchParams.get("compare") : false)
        setCompareType(searchParams.get("compareType") ? searchParams.get("compareType") : "previousPeriod" )
        setType(searchParams.get("type") ? searchParams.get("type") : KeyConstant.THIRTY_DAYS_AGO )
        setCheckCustom(checkCustomFromRange(range))


        setSelectedDateRangeTemp({
            startDate: searchParams.get("startDate") ? moment(searchParams.get("startDate")).toDate() :
                moment().subtract(28, "days").toDate(),
            endDate: searchParams.get("endDate") ? moment(searchParams.get("endDate")).toDate() :
                moment().subtract(1, "days").toDate(),
            key: "selection"
        })
        setCompareTemp(searchParams.get("compare") ? searchParams.get("compare") : false)
        setCompareTypeTemp(searchParams.get("compareType") ? searchParams.get("compareType") : "previousPeriod" )
        setTypeTemp(searchParams.get("type") ? searchParams.get("type") : KeyConstant.THIRTY_DAYS_AGO )
        setCheckCustomTemp(checkCustomFromRange(range))
    },[searchParams])

    const checkCustomFromRange= (range) =>{
        if (moment(range.startDate).format(format) === moment(range.endDate).format(format) &&
            moment(range.startDate).format(format) === moment().format(format)){
            return false
        }
        if (moment(range.startDate).format(format) === moment(range.endDate).format(format) &&
            moment(range.startDate).format(format) === moment().subtract(1, "days").format(format)){
            return false
        }
        if (moment(range.startDate).format(format) === moment().startOf("week").format(format) &&
            moment(range.endDate).format(format) === moment().endOf("week").format(format)){
            return false
        }
        if (moment(range.startDate).format(format) === moment().subtract(1, "weeks").startOf("week").format(format) &&
            moment(range.endDate).format(format) === moment().subtract(1, "weeks").endOf("week").format(format)){
            return false
        }
        if (moment(range.startDate).format(format) === moment().startOf("month").format(format) &&
            moment(range.endDate).format(format) === moment().endOf("month").format(format)){
            return false
        }
        if (moment(range.startDate).format(format) === moment().subtract(1, "month").startOf("month").format(format) &&
            moment(range.endDate).format(format) === moment().subtract(1, "month").endOf("month").format(format)){
            return false
        }
        if (moment(range.startDate).format(format) === moment().subtract(7, "days").format(format) &&
            moment(range.endDate).format(format) === moment().subtract(1, "days").format(format)){
            return false
        }
        if (moment(range.startDate).format(format) === moment().subtract(28, "days").format(format) &&
            moment(range.endDate).format(format) === moment().subtract(1, "days").format(format)){
            return false
        }
        return !( moment(range.startDate).format(format) === moment().subtract(90, "days").format(format) &&
            moment(range.endDate).format(format) === moment().subtract(1, "days").format(format))

    }
    const handleSelect = ranges => {
        setCheckCustom(checkCustomFromRange(ranges.selection))
        setType(ranges.selection.text)
        delete ranges.selection.text;
        setSelectedDateRange(ranges.selection);
    };
    const cancel = () => {
        onCancel()
    }

    const submit = () => {

        searchParams.delete("startDate")
        if (selectedDateRange.startDate) {
            searchParams.append("startDate", selectedDateRange.startDate)
        }

        searchParams.delete("endDate")
        if (selectedDateRange.endDate) {
            searchParams.append("endDate", selectedDateRange.endDate)
        }
        searchParams.delete("type")
        if (type) {
            searchParams.append("type", type)
        }
        searchParams.delete("compare")
        if (compare) {
            searchParams.append("compare", compare)
        }
        searchParams.delete("compareType")
        if (compareType) {
            searchParams.append("compareType", compareType)
        }

        navigate(`?${searchParams.toString()}`)

        dispatch(onReloadData(!reloadData))
        onCancel()
    }

    const convert = () => {
        setSelectedDateRange(selectedDateRangeTemp)
        setCompare(compareTemp)
        setCompareType(compareTypeTemp)
        setType(typeTemp)
        setCheckCustom(checkCustomTemp)
    }

    useEffect(() => {
        if (destroy) {
            convert()
            onDestroy()
            onCancel()
        }
    }, [destroy])

    return (
        <>
            <DateRangePicker
                onChange={handleSelect}
                months={2}
                ranges={[selectedDateRange]}
                direction="horizontal"
                locale={vi}
                staticRanges={staticRanges}
                inputRanges={[]}
                dateDisplayFormat={"dd/MM/yyyy"}
                monthDisplayFormat={"MM/yyyy"}
                showDateDisplay={false}
                fixedHeight={true}
                // rangeColors={["red"]}
                color={["red"]}
            />

            <Row>
                <Col span={24}
                     style={{
                         padding: "10px 20px" ,
                         color: checkCustom ? "rgb(61, 145, 255)" : "" ,
                         fontWeight: checkCustom ? 600 : 400 ,
                         fontFamily: "'Open Sans', sans-serif",
                         fontSize: 13
                     }}>
                    Tùy chỉnh
                </Col>
            </Row>

            <Row style={styleRow}>
                <Col style={styleCol}>
                    <Row>
                        <Col span={18} className={"pl-6"}> So sánh </Col>
                        <Col span={6}> <Switch checked={compare} onChange={(checked) => setCompare(checked)}/> </Col>
                    </Row>

                    {
                        compare &&
                        <>
                            <div style={compareType === "previousPeriod" ? styleDiv : null}
                                 className={"py-1 cursor-pointer hover:bg-slate-200 pl-6"}
                                 onClick={() => setCompareType("previousPeriod")}>
                                Kỳ trước
                            </div>
                            <div style={compareType === "periodLastYear" ? styleDiv : null}
                                 className={"py-1 cursor-pointer hover:bg-slate-200 pl-6"}
                                 onClick={() => setCompareType("periodLastYear")}>
                                Cùng kỳ năm ngoái
                            </div>
                        </>
                    }
                </Col>

                <Col span={18} className={"px-6 py-8"}>
                    <Row>
                        <Col span={6}>
                            <div className={"py-1"} style={styleColor}>{mapNameLastMonth(type)}</div>
                            {
                                compare && <div className={"py-1"} style={styleColor}>{mapPeriod(compareType)}</div>
                            }
                        </Col>
                        <Col span={12}>
                            <div className={"py-1"}>
                                <span className={"mr-6"}>
                                    {moment(selectedDateRange.startDate).format("DD/MM/YYYY")}
                                </span>
                                <span className={"mr-6"}> - </span>
                                <span className={"mr-6"}>
                                    {moment(selectedDateRange.endDate).format("DD/MM/YYYY")}
                                </span>
                            </div>
                            {
                                compare &&
                                <div className={"py-1"}>
                                    <span className={"mr-6"}>
                                        {compareType === "previousPeriod" ?
                                            mapStartDatePeriod(type, selectedDateRange.startDate, selectedDateRange.endDate) :
                                            mapStartDatePeriodLast(selectedDateRange.startDate)
                                        }
                                    </span>
                                    <span className={"mr-6"}> - </span>
                                    <span className={"mr-6"}>
                                        {compareType === "previousPeriod" ?
                                            mapEndDatePeriod(type, selectedDateRange.startDate, selectedDateRange.endDate) :
                                            mapEndDatePeriodLast(selectedDateRange.endDate)
                                        }
                                    </span>
                                </div>
                            }
                        </Col>
                        <Col span={6} className={"flex"}>
                            <div className={"flex items-center"}>
                                <Button className={"mr-3"} onClick={cancel}>
                                    Hủy
                                </Button>
                                <Button type="primary" onClick={submit}>
                                    Áp dụng
                                </Button>
                            </div>
                        </Col>
                    </Row>
                </Col>
            </Row>
        </>
    )
}

export default CalendarModal
